<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00001">
<h2 class="nobreak">CONTENTS</h2>
</div>
<table border="0" cellpadding="2" cellspacing="2" class="calibre8" summary="table">
<tbody class="calibre"><tr class="calibre1">
<td class="tdr"><span class="small">CHAPTER</span></td>
<td class="calibre2"> </td>
<td class="tdr"><span class="small">PAGE</span></td>
</tr>
<tr class="calibre1">
<td class="tdr">I.</td>
<td class="calibre2"><span class="smcap">Why Authors Go Wrong</span></td>
<td class="tdr"><a href="#/Text/Section0003">1</a></td>
</tr>
<tr class="calibre1">
<td class="tdr">II.</td>
<td class="calibre2"><span class="smcap">A Barbaric Yawp</span></td>
<td class="tdr"><a href="#/Text/Section0004">25</a></td>
</tr>
<tr class="calibre1">
<td class="tdr">III.</td>
<td class="calibre2"><span class="smcap">In the Critical Court</span></td>
<td class="tdr"><span href="#/Text/Section0005" title="Link target outside of Sample">39</span></td>
</tr>
<tr class="calibre1">
<td class="tdr">IV.</td>
<td class="calibre2"><span class="smcap">Book “Reviewing”</span></td>
<td class="tdr"><span href="#/Text/Section0006" title="Link target outside of Sample">51</span></td>
</tr>
<tr class="calibre1">
<td class="tdr">V.</td>
<td class="calibre2"><span class="smcap">Literary Editors, by One of Them</span></td>
<td class="tdr"><span href="#/Text/Section0007" title="Link target outside of Sample">103</span></td>
</tr>
<tr class="calibre1">
<td class="tdr">VI.</td>
<td class="calibre2"><span class="smcap">What Every Publisher Knows</span></td>
<td class="tdr"><span href="#/Text/Section0008" title="Link target outside of Sample">119</span></td>
</tr>
<tr class="calibre1">
<td class="tdr">VII.</td>
<td class="calibre2"><span class="smcap">The Secret of the Best Seller</span></td>
<td class="tdr"><span href="#/Text/Section0009" title="Link target outside of Sample">145</span></td>
</tr>
<tr class="calibre1">
<td class="tdr">VIII.</td>
<td class="calibre2"><span class="smcap">Writing a Novel</span></td>
<td class="tdr"><span href="#/Text/Section0010" title="Link target outside of Sample">173</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?56aa2270